<div class="row page-header">
    <div class="col-12">
        <h1>Vehicle Inspection <small>Monthly vehicle safety equipment inspection checklists</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Inspections</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-vehicle-inspection-dashboard (addForEquipment)="onAddForEquipment($event)"></app-vehicle-inspection-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-vehicle-inspection-list></app-vehicle-inspection-list>
    </div>
</div>
